module.exports = __webpack_public_path__ + "img/acasia-upper.e0300919.png";